/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { Badge, BadgeProps, HoverCard } from '@mantine/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle'
import { FormattedMessage } from 'react-intl'

export type ExperimentalBadgeProps = BadgeProps & {
  message?: string
}

function ExperimentalBadge (props: ExperimentalBadgeProps) {
  const { message, ...others } = props
  return (
    <HoverCard openDelay={400}>
      <HoverCard.Target>
        <Badge
          variant="outline"
          color="orange"
          leftSection={<FontAwesomeIcon icon={faExclamationTriangle} />}
          style={{ cursor: 'help' }}
          {...others}
        >
          <FormattedMessage
            id="experimental"
            defaultMessage="Expérimental"
          />
        </Badge>
      </HoverCard.Target>
      <HoverCard.Dropdown maw={300} fz="sm" c="dimmed">
        <FormattedMessage
          id="experimental_feature_desc"
          defaultMessage="Cette fonctionnialité est expérimentale, elle peut etre erronée ou incomplète."
        />
        {message}
      </HoverCard.Dropdown>
    </HoverCard>
  )
}

export default ExperimentalBadge
